export const adminRole = 'admin';
export const userRole = 'user';